import { render, staticRenderFns } from "./PalletInCalifornianList.vue?vue&type=template&id=906b8cda"
import script from "./PalletInCalifornianList.vue?vue&type=script&lang=js"
export * from "./PalletInCalifornianList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports